import { render, staticRenderFns } from "./promotionsHistory.vue?vue&type=template&id=74fefa1c&"
import script from "./promotionsHistory.vue?vue&type=script&lang=js&"
export * from "./promotionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports